export const messagesError: any = {
  blanckLocaName: 'El campo localidad no debe estar vacío',
  validateLocaName:
    'El campo localidad no debe tener números o caracteres especiales.',
};
